/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckChecklistItemStatus } from './PaxCheckChecklistItemStatus';
import {
    PaxCheckChecklistItemStatusFromJSON,
    PaxCheckChecklistItemStatusFromJSONTyped,
    PaxCheckChecklistItemStatusToJSON,
    PaxCheckChecklistItemStatusToJSONTyped,
} from './PaxCheckChecklistItemStatus';
import type { PaxCheckChecklistItemRequirement } from './PaxCheckChecklistItemRequirement';
import {
    PaxCheckChecklistItemRequirementFromJSON,
    PaxCheckChecklistItemRequirementFromJSONTyped,
    PaxCheckChecklistItemRequirementToJSON,
    PaxCheckChecklistItemRequirementToJSONTyped,
} from './PaxCheckChecklistItemRequirement';
import type { PaxCheckRuleOrigin } from './PaxCheckRuleOrigin';
import {
    PaxCheckRuleOriginFromJSON,
    PaxCheckRuleOriginFromJSONTyped,
    PaxCheckRuleOriginToJSON,
    PaxCheckRuleOriginToJSONTyped,
} from './PaxCheckRuleOrigin';

/**
 * Info item - can't be resolved manually
 * @export
 * @interface PaxCheckInfoItem
 */
export interface PaxCheckInfoItem {
    /**
     * Checklist item id
     * @type {string}
     * @memberof PaxCheckInfoItem
     */
    id: string;
    /**
     * Title (localised)
     * @type {string}
     * @memberof PaxCheckInfoItem
     */
    title: string;
    /**
     * Short document title (localised)
     * @type {string}
     * @memberof PaxCheckInfoItem
     */
    shortTitle?: string | null;
    /**
     * Description (localised)
     * @type {string}
     * @memberof PaxCheckInfoItem
     */
    description?: string | null;
    /**
     * Short description (localised)
     * @type {string}
     * @memberof PaxCheckInfoItem
     */
    shortDescription?: string | null;
    /**
     * Any relevant requirements to present to passenger (eg hours to the onward flight for TICKET checklist item type)
     * @type {Array<PaxCheckChecklistItemRequirement>}
     * @memberof PaxCheckInfoItem
     */
    requirements?: Array<PaxCheckChecklistItemRequirement> | null;
    /**
     * External link for more info
     * @type {string}
     * @memberof PaxCheckInfoItem
     */
    externalLink?: string | null;
    /**
     * 
     * @type {PaxCheckRuleOrigin}
     * @memberof PaxCheckInfoItem
     */
    ruleOrigin: PaxCheckRuleOrigin;
    /**
     * 
     * @type {PaxCheckChecklistItemStatus}
     * @memberof PaxCheckInfoItem
     */
    status: PaxCheckChecklistItemStatus;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckInfoItem
     */
    type: string;
}



/**
 * Check if a given object implements the PaxCheckInfoItem interface.
 */
export function instanceOfPaxCheckInfoItem(value: object): value is PaxCheckInfoItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('ruleOrigin' in value) || value['ruleOrigin'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckInfoItemFromJSON(json: any): PaxCheckInfoItem {
    return PaxCheckInfoItemFromJSONTyped(json, false);
}

export function PaxCheckInfoItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckInfoItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'shortTitle': json['short_title'] == null ? undefined : json['short_title'],
        'description': json['description'] == null ? undefined : json['description'],
        'shortDescription': json['short_description'] == null ? undefined : json['short_description'],
        'requirements': json['requirements'] == null ? undefined : ((json['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementFromJSON)),
        'externalLink': json['external_link'] == null ? undefined : json['external_link'],
        'ruleOrigin': PaxCheckRuleOriginFromJSON(json['rule_origin']),
        'status': PaxCheckChecklistItemStatusFromJSON(json['status']),
        'type': json['type'],
    };
}

export function PaxCheckInfoItemToJSON(json: any): PaxCheckInfoItem {
    return PaxCheckInfoItemToJSONTyped(json, false);
}

export function PaxCheckInfoItemToJSONTyped(value?: PaxCheckInfoItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'short_title': value['shortTitle'],
        'description': value['description'],
        'short_description': value['shortDescription'],
        'requirements': value['requirements'] == null ? undefined : ((value['requirements'] as Array<any>).map(PaxCheckChecklistItemRequirementToJSON)),
        'external_link': value['externalLink'],
        'rule_origin': PaxCheckRuleOriginToJSON(value['ruleOrigin']),
        'status': PaxCheckChecklistItemStatusToJSON(value['status']),
        'type': value['type'],
    };
}

